import React, { useEffect, useState } from 'react';
import MeetGeekLogo from '../icons/MeetGeekLogo';

function formatElapsed(seconds) {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) {
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  }
  return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

export default function MeetingHeader({ contextTitle, connectedAt }) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const start = connectedAt || Date.now();
    const tick = () => setElapsed(Math.floor((Date.now() - start) / 1000));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [connectedAt]);

  return (
    <header className="gg-meeting-header">
      <div className="gg-meeting-header__left">
        <div className="gg-meeting-logo" aria-label="Meetgeek">
          <MeetGeekLogo size={22} />
        </div>
        {contextTitle ? (
          <span className="gg-meeting-header__context">{contextTitle}</span>
        ) : null}
      </div>
      <div className="gg-meeting-header__live">
        <span className="gg-meeting-header__live-dot" aria-hidden />
        <span>Live</span>
        <span className="gg-meeting-header__timer">{formatElapsed(elapsed)}</span>
      </div>
    </header>
  );
}
